var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { styled } from '@mui/system';
import { Tooltip, ClickAwayListener, tooltipClasses, Box, } from '@mui/material';
import { isFunction } from '../../utils';
;
var PopoverRoot = styled(function (inProps) {
    var _a = inProps, className = _a.className, props = __rest(_a, ["className"]);
    return (React.createElement(Tooltip, __assign({}, props, { classes: { popper: className } })));
})(function (_a) {
    var _b;
    var _c, _d;
    var theme = _a.theme, arrow = _a.arrow;
    return (_b = {
            zIndex: 1300
        },
        _b["& .".concat(tooltipClasses.tooltip)] = __assign({ backgroundColor: ((_d = (_c = theme.palette) === null || _c === void 0 ? void 0 : _c.common) === null || _d === void 0 ? void 0 : _d.white) || '#fff', color: 'rgba(0, 0, 0, 0.87)', boxShadow: '0px 1px 10px 0px rgb(0 0 0 / 12%)', padding: 0, maxWidth: '100%' }, (arrow === false && {
            margin: '3px !important'
        })),
        _b["& .".concat(tooltipClasses.arrow, ":before")] = {
            color: '#fff',
            boxShadow: '0px 0px 1px 0px rgb(0 0 0 / 12%)',
        },
        _b);
});
var ClickWrapRoot = styled(Box)({
    display: 'inline-block',
});
var TriggerRoot = styled(Box)({
    display: 'inline-block',
});
var ClickWrap = function (_a) {
    var trigger = _a.trigger, children = _a.children, isClickAway = _a.isClickAway, disableReactTree = _a.disableReactTree, mouseEvent = _a.mouseEvent, onClickAway = _a.onClickAway, touchEvent = _a.touchEvent, props = __rest(_a, ["trigger", "children", "isClickAway", "disableReactTree", "mouseEvent", "onClickAway", "touchEvent"]);
    if (trigger !== 'click' || isClickAway === false)
        return children;
    return (React.createElement(ClickAwayListener, { disableReactTree: disableReactTree, mouseEvent: mouseEvent, onClickAway: onClickAway, touchEvent: touchEvent },
        React.createElement(ClickWrapRoot, __assign({}, props), children)));
};
var useOpen = function (_a) {
    var trigger = _a.trigger, openProp = _a.open;
    // 如果open是undefined则交给mui Tooltip 处理
    var isAutomaticOpen = openProp === undefined;
    if (!isAutomaticOpen || trigger === 'hover') {
        return [openProp, function () { return undefined; }];
    }
    var _b = React.useState(false), open = _b[0], setOpen = _b[1];
    var handleSetOpen = function (isOpen) {
        setOpen(isOpen);
    };
    return [open, handleSetOpen];
};
var Popover = React.forwardRef(function (props, ref) {
    var openProp = props.open, disabled = props.disabled, contentProp = props.content, arrow = props.arrow, trigger = props.trigger, placement = props.placement, childrenProp = props.children, onClose = props.onClose, isClickAway = props.isClickAway, TriggerProps = props.TriggerProps, ClickAwayListenerProps = props.ClickAwayListenerProps, onClickAway = props.onClickAway, PopoverProps = __rest(props, ["open", "disabled", "content", "arrow", "trigger", "placement", "children", "onClose", "isClickAway", "TriggerProps", "ClickAwayListenerProps", "onClickAway"]);
    var _a = useOpen({
        open: openProp,
        trigger: trigger,
    }), open = _a[0], setOpen = _a[1];
    var handleClose = function (event) {
        setOpen(false);
        if (isFunction(onClose)) {
            onClose(event);
        }
    };
    var handleOpen = function () {
        if (disabled === false) {
            setOpen(true);
        }
    };
    var handleClickAway = function (event) {
        // bugfix: select在popover内打开自动关闭popover 
        if (event.composedPath().indexOf(document.body) === 0) {
            return;
        }
        if (open === false)
            return;
        var bool = onClickAway === null || onClickAway === void 0 ? void 0 : onClickAway(event);
        if (bool === false) {
            return;
        }
        handleClose(event);
    };
    var disableListeners = {
        disableFocusListener: disabled || trigger !== 'focus',
        disableHoverListener: disabled || trigger !== 'hover',
        disableTouchListener: true,
    };
    var content = null;
    if (typeof contentProp === 'function') {
        content = contentProp({
            handleClose: handleClose,
            handleOpen: handleOpen,
            open: open,
        });
    }
    else {
        content = contentProp;
    }
    var children = null;
    if (typeof childrenProp === 'function') {
        children = childrenProp({
            handleClose: handleClose,
            handleOpen: handleOpen,
            open: open,
        });
    }
    else {
        children = childrenProp;
    }
    return (React.createElement(ClickWrap, __assign({ isClickAway: isClickAway, trigger: trigger, onClickAway: handleClickAway }, ClickAwayListenerProps),
        React.createElement(PopoverRoot, __assign({ ref: ref, open: open, arrow: arrow, placement: placement, onClose: handleClose, title: content, onClick: handleOpen }, disableListeners, PopoverProps),
            React.createElement(TriggerRoot, __assign({}, TriggerProps), children))));
});
Popover.defaultProps = {
    placement: 'bottom',
    trigger: 'click',
    onClose: undefined,
    arrow: true,
    content: null,
    children: null,
    isClickAway: true,
    ClickAwayListenerProps: {},
    TriggerProps: {},
    disabled: false
};
export default Popover;
